import { isFunction } from '../../../../common/base';
import { findNodeByClass } from './util'; // QQ微信登录框

var qqWxFrame = {
  isReady: false,
  $frame: null,
  currentOpt: {},
  // 初始化事件等
  init: function init(opt, callback) {
    var self = this;

    if (self.isReady) {
      isFunction(callback) && callback();
      return;
    } // tpl


    var tpl = "<div class=\"qqwx-login-cover\"></div>\t\t\t<div class=\"qqwx-login-frame qqwx-active-qq\">\t\t\t\t<div class=\"qqwx-tabs\">\t\t\t\t\t<a href=\"javascript:void(0)\" class=\"qq-tab\" data-tab=\"qq\"><i class=\"ico-qq-logo\"></i><span>QQ\u8D26\u53F7\u767B\u5F55</span></a>\t\t\t\t\t<a href=\"javascript:void(0)\" class=\"wx-tab\" data-tab=\"wx\"><i class=\"ico-wx-logo\"></i><span>\u5FAE\u4FE1\u8D26\u53F7\u767B\u5F55</span></a>\t\t\t\t\t<a href=\"javascript:void(0)\" class=\"qqwxtab-close\">\xD7</a>\t\t\t\t</div>\t\t\t\t<div class=\"qqwx-tips\">".concat(opt.showParams.topTips, "</div>\t\t\t\t<div class=\"qqwx-frame\">\t\t\t\t\t<div id=\"milo-qqwx-frame-qq-div\" class=\"qqwx-frame-qq-div\"><iframe src=\"\" frameborder=\"0\" id=\"milo-qqwx-frame-qq\" class=\"qqwx-frame-qq\"></iframe></div>\t\t\t\t\t<div id=\"milo-qqwx-frame-wx-div\" class=\"qqwx-frame-wx-div\"><iframe src=\"\" frameborder=\"0\" id=\"milo-qqwx-frame-wx\" class=\"qqwx-frame-wx\"></iframe></div>\t\t\t\t</div>\t\t\t</div>");
    self.$frame = document.createElement('div');
    self.$frame.classList.add('milo-qqwx-login');
    self.$frame.setAttribute('id', 'qqwx-login');
    self.$frame.innerHTML = tpl;
    document.getElementsByTagName('body')[0].appendChild(self.$frame); // 绑定相关事件

    self.bindEvent();
    self.isReady = true;
    isFunction(callback) && callback();
  },
  bindEvent: function bindEvent() {
    var self = this;

    window.ptlogin2_onClose = function () {
      self.close();
    };

    var closBtn = findNodeByClass(self.$frame, 'qqwxtab-close');

    if (closBtn) {
      closBtn.addEventListener('click', function () {
        self.close();
      });
    } // 切换tab


    var qqTab = findNodeByClass(self.$frame, 'qq-tab');
    var wxTab = findNodeByClass(self.$frame, 'wx-tab');
    var loginFrame = findNodeByClass(self.$frame, 'qqwx-login-frame');
    qqTab.addEventListener('click', function () {
      loginFrame.classList.remove('qqwx-active-wx');
      loginFrame.classList.remove('qqwx-active-qq');
      loginFrame.classList.add('qqwx-active-qq');
    }, false);
    wxTab.addEventListener('click', function () {
      loginFrame.classList.remove('qqwx-active-wx');
      loginFrame.classList.remove('qqwx-active-qq');
      loginFrame.classList.add('qqwx-active-wx');
    }, false);
  },
  close: function close(isForce) {
    if (this.currentOpt.showParams.canClose || isForce) {
      this.$frame.style.display = 'none';
    }
  },
  show: function show(opt) {
    var self = this;
    self.init(opt, function () {
      self.currentOpt = opt;
      var cover = findNodeByClass(self.$frame, 'qqwx-login-cover');
      var loginFrame = findNodeByClass(self.$frame, 'qqwx-login-frame');
      /* showParams相关*/
      // zIndex

      var zIndex = Number(opt.showParams.zIndex) || 999;
      self.$frame.style.zIndex = zIndex;
      cover.style.zIndex = zIndex;
      loginFrame.style.zIndex = zIndex + 1; // 是否显示cover

      if (opt.showParams.needMask) {
        cover.style.display = 'block';
      } else {
        cover.style.display = 'none';
      } // 是否允许关闭[显示关闭按钮]


      var closBtn = findNodeByClass(self.$frame, 'qqwxtab-close');

      if (!opt.showParams.canClose) {
        closBtn.style.display = 'none';
      } else {
        closBtn.style.display = 'block';
      }

      self.$frame.style.display = 'block';
    });
  }
};
export default qqWxFrame;